import AssessmentApiCall from 'ASSESSMENT/AssessmentApiCall';
import SuccessModal from 'ASSESSMENT/CommonResources/SuccessModal/SuccessModal';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import 'ASSESSMENT/Components/GradeCardList/gradecardlist.css';
import Spinner from 'ASSESSMENT/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactToPrint from 'react-to-print';

class GradeCardList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            instituteUrl: this.props.match.params.instituteUrl,
            instituteData: {},
            instituteId: "",
            isValidUrl: '',

            // search by variables
            searchBy: "erpId",
            searchedValue: "",
            searchMapping: {
                "erpId": "ERP Id",
                "prn": "PRN/University Number",
                "emailId": "Registered Email-Id",
                "mobile": "Registered Mobile Number",
            },
            searchErrorMsg: "",

            // student variables
            studentData: {},
            studentId: '',
            verifyingStudent: false,
            validStudent: '',

            sortedAcaYrArray: [],
            academicYearList: {},
            selectedAcaYr: '',

            gradeCardList: {},
            sortedGradeCardArray: [],
            fetchingGradeCard: false,

            viewGradeCard: false,
            gradeCardDetails: "",
        }
    }

    componentDidMount () {
        // METHOD CALLED TO MAKE API CALL TO GET INSTITUTE DATA
        this.apiCallToGetInstituteDetails();

        // METHOD CALLED TO MAKE API CALL TO GET ACADEMIC YEAR LIST
        this.apiCallToGetAcademicYearList();
    }

    // API CALL METHOD TO GET RESULT LIST
    apiCallToGetInstituteDetails = async () => {
        let requestData = {
            "url": this.state.instituteUrl,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getInstituteDataByURL',
            requestData,
            '/api/assessment/assessmentLogin/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if(jsonResponse.APIResult.success == "true")
                {
                    this.setState({
                        instituteData: apiResult,
                        instituteId: apiResult.InstituteId,
                        isValidUrl: "true"
                    });
                }
                else
                {
                    this.setState({
                        isValidUrl: "false"
                    });
                }
            } else {
                this.setState({
                    isResultFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute data. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET RESULT LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "url": this.state.instituteUrl,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    academicYearList: apiResult,
                    sortedAcaYrArray: jsonResponse.APIResult.sortedIdArray
                });
                
            } else {
                this.setState({
                    isResultFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute data. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO VERIFY STUDENT DETAILS
    apiCallToVerifyStudentDetails = async () => {
        this.setState({
            verifyingStudent: true
        });

        let requestData = {
            "iid": this.state.instituteId,
            "search_by": this.state.searchBy,
            "search_value": this.state.searchedValue,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'assessmentVerifyStudentForPublicLink',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToVerifyStudentDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if(jsonResponse.APIResult.isValid == "true")
                {
                    this.setState({
                        studentData: apiResult,
                        studentId: apiResult.studentId,
                        verifyingStudent: false,
                        validStudent: 'true'
                    });
                }
                else
                {
                    this.setState({
                        verifyingStudent: false,
                        validStudent: 'false'
                    });
                }
            } else {
                this.setState({
                    verifyingStudent: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute data. Please try again later.'
                });
            }
        }
    }

    // METHOD TO VALIDATE STUDENT SEARCH
    validateStudentSearch = () => {
        let valid = true;

        if(this.state.searchBy == "" || this.state.searchedValue.trim() == "")
        {
            valid = false;
        }

        if(valid)
        {
            this.setState({
                studentData: {},
                studentId: '',
                validStudent: '',
                selectedAcaYr: '',
                gradeCardList: {},
                sortedGradeCardArray: [],
                fetchingGradeCard: false,
                viewGradeCard: false,
                gradeCardDetails: "",
            })
            this.apiCallToVerifyStudentDetails();
        }
        else
        {
            this.setState({
                searchErrorMsg: "Please enter the details to view the grade card."
            });
        }
    }

    // API CALL METHOD TO GET STUDENT GRADE CARD LIST
    apiCallToGetStudentGradeCardList = async () => {
        this.setState({
            fetchingGradeCard: true
        });

        let requestData = {
            "iid": this.state.instituteId,
            "studentId": this.state.studentId,
            "acaYr": this.state.selectedAcaYr,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'assessment_getStudentGradeCardList',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetStudentGradeCardList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    gradeCardList: apiResult,
                    sortedGradeCardArray: jsonResponse.APIResult.sortedIdArray,
                    fetchingGradeCard: false
                });
            } else {
                this.setState({
                    fetchingGradeCard: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting grade card list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET STUDENT GRADE CARD DETAILS
    apiCallToGetStudentGradeCardDetails = async (gradeCardId) => {
        this.setState({
            fetchingStudentGradeCard: true
        });

        let requestData = {
            "iid": this.state.instituteId,
            "studentId": this.state.studentId,
            "gradeCardId": gradeCardId,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'assessment_getStudentGradeCard',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetStudentGradeCardDetails(gradeCardId)
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    gradeCardDetails: apiResult.gradeCardDetails,
                    fetchingStudentGradeCard: false
                });
            } else {
                this.setState({
                    fetchingStudentGradeCard: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting grade card list. Please try again later.'
                });
            }
        }
    }

    closeViewGradeCard(){
        this.setState({
            viewGradeCard: false,
            gradeCardDetails: "",
        })
    }

    returnViewGradeCard = () => {
        return (
            <div className={this.state.viewGradeCard ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal modal-xl" >
                    <div className="modal-content p-3 overflow-auto" style={{ gap: "24px", maxHeight: "90vh" }}>
                        <div id="scheduleAssessmentHeader" className="d-flex align-items-center justify-content-between">
                            <div className="fs-large font-weight-bold">Grade Card</div>
                            <div className="d-flex align-items-center">
                                <div className="pointer">
                                    <ReactToPrint
                                        trigger={() => {
                                            return (
                                                <button className='btn btn-outline-primary'>
                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' />
                                                </button>
                                            );
                                        }}
                                        content={() => this.printReference}
                                    />
                                </div>
                                <div className="rounded-circle d-flex justify-content-center align-items-center pointer ml-3" style={{ width: "30px", height: "30px", cursor: 'pointer' }} onClick={() => this.closeViewGradeCard()}>
                                    <FontAwesomeIcon icon={['fas', 'times']} size='md' color='black' />
                                </div>
                            </div>
                        </div>
                        {
                            this.state.fetchingStudentGradeCard ?
                                <Spinner />
                                :
                                <>
                                    {
                                        this.state.gradeCardDetails !== "" ?
                                            <div className="mt-3 print-css overflow-auto" ref={el => this.printReference = el}>
                                                {ReactHtmlParser(this.state.gradeCardDetails)}
                                            </div> :
                                            <div className="fs-small secondary-text">no Grade Card data found</div>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        return(
            <>
                {
                    this.state.isValidUrl == "true" ?
                        <>
                            <div className='container-fluid'>
                                <div className='institute-header'>
                                    <div className='institute-logo'>
                                        
                                        <img src={this.state.instituteData.InstituteLogo} height={40} alt='Institute Logo' />
                                    </div>
                                    <div className='institute-name'>
                                        {
                                            ReactHtmlParser(this.state.instituteData.InstituteName)
                                        }
                                    </div>
                                </div>
                                <hr/>
                                <div className='page-title'>
                                    <h4>View Grade Card</h4>
                                </div>
                                <div className='student-search-container'>
                                    <div className='search-input-container'>
                                        <div>
                                            <label style={{ fontWeight: 'bold' }}>Search By</label>
                                            <select className='form-control' value={this.state.searchBy} onChange={(e) => this.setState({ searchBy: e.target.value })}>
                                                <option value="erpId">ERP Id</option>
                                                <option value="prn">PRN/University Number</option>
                                                <option value="emailId">Registered Email-Id</option>
                                                <option value="mobile">Registered Mobile Number</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 'bold' }}>Enter {this.state.searchMapping[this.state.searchBy]}</label>
                                            <input className='form-control' type='text' placeholder={`Enter ${this.state.searchMapping[this.state.searchBy]}`} value={this.state.searchedValue} onChange={(e) => this.setState({searchedValue: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className='button-container'>
                                        <button 
                                            className='btn btn-primary'
                                            onClick={() => this.setState({searchErrorMsg: ""}, () => {this.validateStudentSearch()}) }
                                            disabled={this.state.searchedValue.trim() == ""}
                                        >
                                            Proceed
                                        </button>
                                    </div>
                                </div>

                                {
                                    this.state.validStudent == "true" ?
                                        <>
                                            <hr/>
                                            <div className='student-details-container'>
                                                <div>
                                                    <span style={{ fontWeight: 'bold', marginRight: '5px' }}>
                                                        Student ERP Id: 
                                                    </span>
                                                    <span>
                                                        {this.state.studentData.studentERPId}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ fontWeight: 'bold', marginRight: '5px' }}>
                                                        Student Name: 
                                                    </span>
                                                    <span>
                                                        {this.state.studentData.studentName}
                                                    </span>
                                                </div>
                                                <div className='grade-card-list-container'>
                                                    <div>
                                                        <select className='form-control' value={this.state.selectedAcaYr} onChange={(e) => this.setState({ selectedAcaYr: e.target.value }, () => this.apiCallToGetStudentGradeCardList())} >
                                                            <option value="">Select Academic Year</option>
                                                            {
                                                                this.state.sortedAcaYrArray.map(yearId => {
                                                                    let yearDetails = this.state.academicYearList[yearId];

                                                                    return (
                                                                        <option value={yearId}>{yearDetails.year_text}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='grade-card-list'>
                                                <div className='table-container'>
                                                    <table className='table table-bordered' style={{ width: '800px' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ padding: '5px' }}>Sr.No.</th>
                                                                <th style={{ padding: '5px' }}>Grade Card Title</th>
                                                                <th style={{ padding: '5px' }}>Grade Card</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.fetchingGradeCard ?
                                                                    <Spinner />
                                                                :
                                                                    Object.keys(this.state.gradeCardList).length > 0 ?
                                                                        this.state.sortedGradeCardArray.map((gradeCardId, index) => {
                                                                            let gradeCard = this.state.gradeCardList[gradeCardId];

                                                                            return (
                                                                                <>
                                                                                    <tr>
                                                                                        <td style={{ padding: '5px' }}>{index + 1}</td>
                                                                                        <td style={{ padding: '5px' }}>{gradeCard.title}</td>
                                                                                        <td style={{ padding: '5px' }}>
                                                                                            <span style={{ color: '#0465ac', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => this.setState({ viewGradeCard: true }, () => {this.apiCallToGetStudentGradeCardDetails(gradeCardId)}) }>View</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })
                                                                    :
                                                                        <tr>
                                                                            <td style={{ padding: '5px' }} colSpan={3}>
                                                                                {
                                                                                    this.state.selectedAcaYr != '' ?
                                                                                        "Grade cards not generated for the selected academic year."
                                                                                    :
                                                                                        "Please select the academic year to view the generated grade cards."
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </>
                                    :
                                        this.state.validStudent == "false" &&
                                            <div className="invalid-student">
                                                <p>The {this.state.searchMapping[this.state.searchBy]} entered is invalid. Please check once and try again.</p>
                                            </div>
                                        
                                }
                            </div>
                            {
                                this.state.successModal &&
                                    <SuccessModal 
                                        successModal={this.state.successModal} 
                                        successModalType={this.state.successModalType}
                                        successMessage={this.state.successMessage}
                                        closeSuccessModal={this.closeSuccessModal} 
                                    />
                            }

                            {
                                this.state.viewGradeCard &&
                                    this.returnViewGradeCard()
                            }
                        </>
                    :
                        <div className="invalid-url">
                            <p>Invalid URL.</p>
                        </div>
                }
            </>
        )
    }
}

export default GradeCardList;